import styled from '@emotion/styled';
import User from '../../../../entity/User';
import { AppBar, Toolbar } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler, useContext } from 'react';
import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import mq from '../../../styleUtility/mediaquery';
import _KaizenPlatformLogo from '../../primitive/KaizenPlatformLogo';
import { context as DependencyContext } from '../../../context/dependency';
import Language from '../../../../entity/Language';
import _UserMenu from './UserMenu';
import RouterLink from '../../primitive/RouterLink';
import LangMenu from './LangMenu';

export const HEADBAR_HEIGHT = 56;

interface Props {
  signedInUser: User;
  onClickAccountSettings: MouseEventHandler<HTMLElement>;
  onClickSignOut: MouseEventHandler<HTMLElement>;
  className?: string;
}

const HeadBar = ({
  signedInUser,
  onClickAccountSettings,
  onClickSignOut,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const dependency = useContext(DependencyContext);
  return (
    <StyledAppBar color="default" elevation={2} className={className}>
      <StyledToolbar>
        <LogoContainer href={`/users/${signedInUser.id}`}>
          <KaizenPlatformLogo />
        </LogoContainer>
        <SettingContainer>
          <LangMenu
            onSubmit={(lang: Language) => {
              dependency.configurationChangingUsecase.changeLanguage(lang);
              dependency.messageDispatcher.notifyUnimportant('user_setting.general.lang_updated');
            }}
          />
          <UserMenu
            signedInUser={signedInUser}
            onClickSignOut={onClickSignOut}
            onClickAccountSettings={onClickAccountSettings}
          />
        </SettingContainer>
      </StyledToolbar>
    </StyledAppBar>
  );
};

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#fff',
}) as typeof AppBar;

const StyledToolbar = styled(Toolbar)(
  gridLayoutContainer({
    columns: ['200px', '1fr', 'auto'],
    rows: ['1fr'],
    areas: [['logo', '.', 'setting_menu']],
    alignItems: 'center',
  }),
  {
    gridColumnGap: SPACING_UNIT * 3,
    height: HEADBAR_HEIGHT,
    minHeight: HEADBAR_HEIGHT,
    [mq('sp')]: {
      ...gridLayoutContainer({
        columns: ['200px', 'auto'],
        rows: ['1fr'],
        areas: [['logo', 'setting_menu']],
        alignItems: 'center',
      }),
    },
  },
) as typeof Toolbar;

const LogoContainer = styled(RouterLink)(gridLayoutItem('logo'), {
  justifySelf: 'flex-start',
  cursor: 'pointer',
});

const KaizenPlatformLogo = styled(_KaizenPlatformLogo)({
  paddingBottom: 2,
});

const SettingContainer = styled('div')(gridLayoutItem('setting_menu'), {
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
});

const UserMenu = styled(_UserMenu)({
  '& p': {
    [mq('sp')]: {
      display: 'none',
    },
  },
});

export default HeadBar;
